import React, {
    useContext,
} from 'react'
import {
    THCellButtonFilterContainer,
    ThCellFilterButton,
    ThCellFilterButtonSortIcon,
    ThCellFilterButtonFilterIcon,
    ThCellFilterButtonIcon
} from "components/Table/TableHeader/style";
import { Popover } from "@mui/material";
import FilterSortCell from "components/Table/TableHeader/FilterSortCell";
import TableDataContext from "components/Table/context/context";



const ThCellButtonFilter = ({ col }: any) => { // Filter button
    const { sort, filter } = useContext(TableDataContext)
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const id = !!anchorEl ? 'simple-popover' : undefined;

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const [isSort, isFilter, isAsc] = [sort?.field === col?.id, (()=>{
        if (Object.keys(filter).length === 0) return false
        if (['s1', 's2', 's3', 's4', 's5'].includes(col.fieldName)) {
        const keys  = Object.keys(filter)
        return keys.some(key  => key.startsWith(col.fieldName) && /(Us|Ca)$/.test(key))
       }
        return !!filter[col?.id]
    })(), sort?.direction]

    return (
        <THCellButtonFilterContainer>
            <ThCellFilterButton size="small" aria-describedby={id} onClick={handleClick} isActive={isSort || isFilter} _asc={isAsc}>
                {!isSort && !isFilter ? <ThCellFilterButtonIcon /> : isSort ? <ThCellFilterButtonSortIcon /> : <ThCellFilterButtonFilterIcon />}
            </ThCellFilterButton>
            <Popover
                id={id}
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <FilterSortCell col={col} onClose={handleClose} />
            </Popover>
        </THCellButtonFilterContainer>
    )
}



export default ThCellButtonFilter
